import type { LucideIcon } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { cn } from '@/lib/utils';
import { ACCENT_MARK_CLASS } from '@/styles/accentMark';
import { RAISED_CARD_CLASS } from '@/styles/raisedCard';
import { DetailItem, type DetailItemProps } from './DetailItem';

const COLUMNS_CLASS = {
  2: '@sm:grid-cols-2',
  3: '@sm:grid-cols-2 @2xl:grid-cols-3',
} as const;

interface ProfileDetailSectionProps {
  title: string;
  icon: LucideIcon;
  fields: DetailItemProps[];
  isLoading?: boolean | undefined;
  columns?: keyof typeof COLUMNS_CLASS;
}

export function ProfileDetailSection({
  title,
  icon: Icon,
  fields,
  isLoading,
  columns = 3,
}: ProfileDetailSectionProps) {
  return (
    <Card className={RAISED_CARD_CLASS}>
      <CardContent className="flex flex-col gap-4">
        <div className="flex items-center gap-2.5">
          <div
            className={cn('flex size-8 items-center justify-center rounded-lg', ACCENT_MARK_CLASS)}
          >
            <Icon className="size-4" aria-hidden />
          </div>
          <h3 className="text-base font-semibold">{title}</h3>
        </div>
        <div className="@container">
          <div className={cn('grid grid-cols-1 gap-3', COLUMNS_CLASS[columns])}>
            {fields.map((field) => (
              <DetailItem key={field.label} {...field} isLoading={isLoading} />
            ))}
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
